import React, { useState, useEffect } from "react";
import { FaCheck, FaBan, FaEdit } from "react-icons/fa";
import { usePut } from "../../customHooks/usePut"; 
import { useGet } from "../../customHooks/useGet";
import { useAuthProvider } from "../../customHooks/authContext";
import "bootstrap/dist/css/bootstrap.min.css"; 
import MemberEdit from "./MemberEdit";
import { useLocation, useNavigate } from "react-router-dom";
function MemberTable() {
    const location = useLocation();
    
    const { school: contextSchool, token } = useAuthProvider();
    const { schoolselected } = location.state || {};
  
    console.log("schoolselected (raw):", schoolselected);
  
    const normalizedSchool =
    contextSchool?.id ? contextSchool
    : typeof schoolselected === "object"
      ? schoolselected
      : { id: Number(schoolselected)};
  
    const schoolId = normalizedSchool?.id;
  
    console.log("Normalized School:", normalizedSchool);
    console.log("schoolId:", schoolId);

  const [currentPage, setCurrentPage] = useState(0); // Estado para la página actual
  const [pageSize] = useState(10); // Tamaño de la página (número de miembros por página)

  
  const API_BASE_URL = schoolId
    ? `https://ectech-software.com.ar/api/academy/schools/${schoolId}/members`
    : null;

  // Cargar los miembros con paginación
  const { data: membersData, error, loading, refetch } = useGet(
    schoolId ? `${API_BASE_URL}?page=${currentPage}&size=${pageSize}` : null
  );

  useEffect(() => {
    if (membersData?.content) {
      console.log("Miembros obtenidos:", membersData.content);
    }
  }, [membersData]);

  const [members, setMembers] = useState([]);
  const { executePut } = usePut(); 
  const [selectedMember, setSelectedMember] = useState(null);

  useEffect(() => {
    if (membersData?.content) {
      setMembers(membersData.content);
    }
  }, [membersData]);

  const handleToggleEnabled = async (member) => {
    try {
      const updatedMember = { ...member, status: !member.status };
      const response = await executePut(`${API_BASE_URL}/${member.id}`, updatedMember); 

      if (!response) throw new Error("No se pudo actualizar el estado del miembro.");
      await refetch();
    } catch (error) {
      console.error("Error al actualizar el estado del miembro:", error);
      alert(`Error al cambiar el estado del miembro: ${error.message}`);
    }
  };

  const handleOpenEdit = (member) => {
    setSelectedMember(member);
  };

  const handleCloseEdit = () => {
    setSelectedMember(null);
    refetch();
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage); // Cambiar la página actual
  };

  return (
    <div className="container mt-4">
      {loading && <p className="loading" role="alert">Cargando miembros...</p>}
      {error && <p className="error" role="alert">Error al obtener miembros: {error.message}</p>}

      {!loading && !error && (
        <div className="">
          <table className="table table-bordered table-hover">
            <thead className="table-primary text-center">
              <tr>
              <th style={{ width: '100px' }}>Nombre</th>
              <th style={{ width: '100px' }}>Apellido</th>
              <th style={{ width: '60px' }}>Fecha de Nacimiento</th>
              <th style={{ width: '90px' }}>Estado</th>
              <th style={{ width: '90px' }}>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {members.length > 0 ? (
                members.map((member) => (
                  <MemberRow
                    key={member.id}
                    member={member}
                    onToggleEnabled={handleToggleEnabled}
                    onEdit={() => handleOpenEdit(member)}
                  />
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center">No hay miembros disponibles</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* Paginación */}
      <div className="d-flex justify-content-center mt-4">
        <button
          className="btn btn-primary me-2"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 0}
        >
          Anterior
        </button>
        <button
          className="btn btn-primary"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={membersData?.totalPages - 1 === currentPage}
        >
          Siguiente
        </button>
      </div>

      {selectedMember && (
        <div className="member-edit-container">
          <MemberEdit
            member={selectedMember}
            schoolId={schoolId}
            onClose={handleCloseEdit}
            refetch={refetch}
          />
        </div>
      )}
    </div>
  );
}

const MemberRow = React.memo(({ member, onToggleEnabled, onEdit }) => {
  const memberDate = member.birthdate
    ? new Date(member.birthdate).toLocaleDateString('es-ES', { timeZone: 'UTC' })
    : "Sin fecha";

    return (
    <tr>
      <td className= "text-left">{member.name}</td>
      <td className= "text-left">{member.surname}</td>
      <td className= "text-center">{memberDate}</td>
      <td className={member.status ? "text-success text-center fw-bold" : "text-danger text-center fw-bold"}>
        {member.status ? "Activo" : "Inactivo"}
      </td>
      <td className="text-center">
        <button
          onClick={() => onToggleEnabled(member)}
          className={`btn ${member.status ? "btn-danger" : "btn-success"} me-2`}
          aria-label={member.status ? "Deshabilitar miembro" : "Habilitar miembro"}
        >
          {member.status ? <FaBan /> : <FaCheck />}
        </button>
        <button
          onClick={onEdit}
          className="btn btn-warning"
          aria-label="Editar miembro"
        > 
          <FaEdit /> Modificar
        </button>
      </td>
    </tr>
  );
});

export default MemberTable;
